/*
  Ported from src/components/Header.tsx — blur-on-scroll past 40px, mobile
  menu toggle, and a live cart badge (fetches /cart.js after any add-to-cart
  on the page, via the 'cart:updated' event dispatched by oblivion-pdp.js).
*/
(function () {
  function initScroll(header) {
    // The window scrolls at every width (oblivion-tokens.css undoes Horizon's
    // desktop lock). Also listen on .page-wrapper as a fallback in case that
    // override is ever removed.
    var wrapper = document.querySelector('.page-wrapper');
    function onScroll() {
      var y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
      header.classList.toggle('is-scrolled', y > 40);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
  }

  function initMenu(header) {
    var toggle = header.querySelector('[data-header-menu-toggle]');
    var menu = header.querySelector('[data-header-mobile-menu]');
    var menuIcon = header.querySelector('[data-header-menu-icon]');
    var closeIcon = header.querySelector('[data-header-close-icon]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = !menu.hidden;
      menu.hidden = isOpen;
      if (menuIcon) menuIcon.hidden = !isOpen;
      if (closeIcon) closeIcon.hidden = isOpen;
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.hidden = true;
        if (menuIcon) menuIcon.hidden = false;
        if (closeIcon) closeIcon.hidden = true;
      });
    });
  }

  function initCartBadge(header) {
    var badge = header.querySelector('[data-header-cart-badge]');
    if (!badge) return;

    function refresh() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.hidden = false;
          } else {
            badge.hidden = true;
          }
        });
    }

    document.addEventListener('cart:updated', refresh);
  }

  document.querySelectorAll('[data-oblivion-header]').forEach(function (header) {
    initScroll(header);
    initMenu(header);
    initCartBadge(header);
  });
})();
